function errorMessage (errorCode) {
  let errorTip = '未知错误'
  switch (errorCode) {
    case 10001:
      errorTip = '园区名称已存在'
      break
    case 10003:
      errorTip = '创建最大级别'
      break
    case 10004:
      errorTip = '当前房间存在住户，不能删除'
      break
    case 10005:
      errorTip = '房间ID不能为空'
      break
    case 10006:
      errorTip = '房间号已存在'
      break
    case 10007:
      errorTip = '住户已存在'
      break
    case 10008:
      errorTip = '住户不存在'
      break
    case 10009:
      errorTip = '楼层下存在房间'
      break
    case 11111:
      errorTip = '参数有误'
      break
    case 21001:
      errorTip = '手机号已存在'
      break
    case 21002:
      errorTip = '人员不存在'
      break
    case 22001:
      errorTip = '卡类型已存在'
      break
    case 22002:
      errorTip = '添加卡类型失败'
      break
    case 22003:
      errorTip = '该卡类型绑定了人员'
      break
    case 22004:
      errorTip = '园区名称错误'
      break
    case 22005:
      errorTip = '园区编号错误'
      break
    case 22006:
      errorTip = '支付宝账号名称已存在'
      break
    case 22007:
      errorTip = '支付宝账号已存在'
      break
    case 22008:
      errorTip = '卡类型不存在'
      break
    case 23003:
      errorTip = '配置的appid错误'
      break
    case 23004:
      errorTip = '应用未授权'
      break
    case 23005:
      errorTip = '更新模板失败'
      break
    case 23006:
      errorTip = '创建模板失败'
      break
    case 23007:
      errorTip = '卡包不存在'
      break
    case 23009:
      errorTip = '授权过期'
      break
    case 23010:
      errorTip = '卡包模板不存在'
      break
    case 23011:
      errorTip = '领卡时 身份不匹配'
      break
    case 23012:
      errorTip = '支付宝账号已绑定'
      break
    case 23013:
      errorTip = '人员不存在  请前往申请'
      break
    case 23014:
      errorTip = '支付宝账户不存在'
      break
    case 23015:
      errorTip = '两次授权账户不一致'
      break
    case 23016:
      errorTip = '支付宝账号授权失败'
      break
    case 24001:
      errorTip = '房源面积超过楼层最大值'
      break
    case 24002:
      errorTip = '该楼层下存在房源'
      break
    case 24003:
      errorTip = '已分配空间大于将要修改的每层面积'
      break
    case 24004:
      errorTip = '输入楼层不能为0或空'
      break
    case 25001:
      errorTip = '该角色下楼栋权限不存在'
      break
    case 31090:
      errorTip = '设备编号已存在'
      break
    case 31091:
      errorTip = '设备名称已存在'
      break
    case 31092:
      errorTip = '请选择门禁设备'
      break
    case 31093:
      errorTip = '公共场景不需要授权'
      break
    case 31095:
      errorTip = '设备不存在'
      break
    case 41001:
      errorTip = '该账号所对应的角色下没有任何权限'
      break
    case 41002:
      errorTip = '该账号所对应的角色不存在'
      break
    case 41003:
      errorTip = '该角色名已存在'
      break
    case 42001:
      errorTip = '账号名称已存在'
      break
    case 42003:
      errorTip = '账号不存在'
      break
    case 42004:
      errorTip = '账号密码错误'
      break
    case 42005:
      errorTip = '账号归属错误'
      break
    case 42006:
      errorTip = '验证码输入错误'
      break
    case 42007:
      errorTip = '验证码已失效'
      break
    case 50001:
      errorTip = '代办记录不存在'
      break
    case 50002:
      errorTip = '代办编号已存在'
      break
    case 50003:
      errorTip = '订单已处理，请不要重复处理'
      break
    case 53001:
      errorTip = '只能同时申请一张卡'
      break
    case 53002:
      errorTip = '申请表不存在'
      break
    case 91001:
      errorTip = '邮箱格式错误'
      break
    case 91002:
      errorTip = '手机号码格式错误'
      break
    case 91003:
      errorTip = '名称格式错误'
      break
    case 91004:
      errorTip = '身份证格式错误'
      break
    case 91005:
      errorTip = '参数错误'
      break
    case 91006:
      errorTip = '图片上传错误'
      break
    case 91007:
      errorTip = '登录超时，请重新登录'
      break
    case 91008:
      errorTip = '权限不足'
      break
    case 91010:
      errorTip = '设备已存在'
      break
    case 91110:
      errorTip = '设备名已存在'
      break
    case 91210:
      errorTip = '该车辆已授权'
      break
    default:
      errorTip = '未知错误'
  }
  return errorTip
}
export { errorMessage }



// WEBPACK FOOTER //
// ./src/utils/errorCode.js